const paginationMicrocopy = () => {
  return {}
}

export default { paginationMicrocopy }
